/**
 * Tauscht variantenabhängige Inhalte (Titel, Beschreibung) beim Variantenwechsel aus.
 * Horizon rendert die Section für die neue Variante neu und liefert das HTML im
 * Ergebnis des Auswahlereignisses; übernommen wird das Element mit demselben data-key,
 * nach dem Muster der Bildergalerie in media-gallery.js.
 */
class ElliVariantContent extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const target = this.closest('.shopify-section, dialog');
    target?.addEventListener('shopify:product:select', this.#handleProductSelect, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = new AbortController();
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        const html = detail?.html;
        if (!html || !this.dataset.key) return;

        const next = html.querySelector(`elli-variant-content[data-key="${CSS.escape(this.dataset.key)}"]`);
        if (next && next.innerHTML !== this.innerHTML) this.innerHTML = next.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[elli-variant-content] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('elli-variant-content')) {
  customElements.define('elli-variant-content', ElliVariantContent);
}
